import { render } from "./V9StyleBottom.vue?vue&type=template&id=997851aa&scoped=true"
import script from "./V9StyleBottom.vue?vue&type=script&lang=js"
export * from "./V9StyleBottom.vue?vue&type=script&lang=js"

import "./V9StyleBottom.vue?vue&type=style&index=0&id=997851aa&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-997851aa"]])

export default __exports__